<template>
  <v-dialog
    v-model="value"
    transition="dialog-top-transition"
    max-width="400"
  >
      <v-card>
        <v-toolbar
          color="primary"
          dark
        >Пол сотрудника</v-toolbar>
        <v-card-text>
          <v-container>
            <v-radio-group
              v-model="sex"
              row
            >
              <v-radio
                label="Мужской"
                on-icon="mdi-gender-male"
                color="indigo"
                value="1"
              ></v-radio>
              <v-radio
                label="Женский"
                on-icon="mdi-gender-female"
                color="pink"
                value="0"
              ></v-radio>
            </v-radio-group>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="$emit('input', false)"
          >Отмена</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="choosePos"
          >Сохранить</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['value', 'sexID'],
  components: {

  },
  data () {
    return {
      locSexID: null
    }
  },
  computed: {
    sex: {
      get: function () {
        if (this.locSexID) {
          return this.locSexID
        } else {
          return this.sexID
        }
      },
      set: function (val) {
        this.locSexID = val
      }
    }
  },
  methods: {
    choosePos () {
      if (this.sex !== this.sexID) {
        this.$emit('onSexChanged', this.sex)
      }
      this.$emit('input', false)
    }
  }
}
</script>
